/* ensure only one detail is open at a time for filters */
// Fetch all the details element in filter-collection
const details = document.querySelectorAll(".filter-collection details")

// Add the onclick listeners.
details.forEach((detail) => {
  detail.addEventListener("toggle", () => {
    if (detail.open) setTargetDetail(detail)
  })
})

// Close all the details that are not targetDetail.
function setTargetDetail(targetDetail) {
  details.forEach((detail) => {
    if (detail !== targetDetail) {
      detail.open = false
    }
  })
}
